(function () {
  const STYLE_ID = 'upm-customer-referral-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.innerHTML = `
      .sca_aff_customer_refer_shop_now_overlay {
        height: 100% !important;
        width: 100% !important;
        background: rgba(0, 0, 0, 0.5) !important;
      }

      .sca_aff_customer_refer_shop_now_container.wgt-contrast-element {
        margin: auto !important;
      }
    `;
    document.head.appendChild(style);
  }

  function checkAndApply() {
    const overlay = document.querySelector('.sca_aff_customer_refer_shop_now_overlay');
    const container = document.querySelector('.sca_aff_customer_refer_shop_now_container.wgt-contrast-element');

    if (overlay || container) {
      injectStyle();
    }
  }

  const observer = new MutationObserver(checkAndApply);

  function init() {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    checkAndApply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();